import { createContext, useContext } from "react";
import { Company } from "models/Company";

type CompaniesContextProps = {
  children: React.ReactNode;
  companies: Company[];
  setSelectedCompanyId: (id: string) => void;
  selectedCompany: Company | null;
};

const CompaniesContext = createContext<
  | {
      companies: Company[] | undefined;
      selectedCompany: Company | null;
      setSelectedCompanyId: (id: string) => void;
    }
  | undefined
>(undefined);

const useCompaniesContext = () => {
  const context = useContext(CompaniesContext);
  if (!context) {
    throw new Error("useCompaniesContext must be used within an CompaniesProvider");
  }
  return context;
};

const CompaniesProvider: React.FC<CompaniesContextProps> = ({
  children,
  companies,
  selectedCompany,
  setSelectedCompanyId,
}) => {
  return (
    <CompaniesContext.Provider value={{ companies, selectedCompany, setSelectedCompanyId }}>
      {children}
    </CompaniesContext.Provider>
  );
};

export { CompaniesProvider as default, useCompaniesContext };
